import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule, MatCardTitle } from '@angular/material/card';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { pluck } from 'rxjs';
import { EamService } from 'src/app/services/eam.service';


export interface EAMListDialogData {
  eamAsset: string
}

@Component({
  selector: 'app-eam-work-request-list',
  imports: [CommonModule, MatCardModule, MatDialogModule, MatButtonModule],
  templateUrl: './eam-work-request-list.component.html',
  styleUrl: './eam-work-request-list.component.scss'
})
export class EamWorkRequestListComponent {
  private svcEAM = inject(EamService);

  datasource:any[] = [];
  AssetName:string;
  workOrdersExist: boolean = false;
  isLoading: boolean = true;


  constructor(private dialog: MatDialog,
    private dialogRef: MatDialogRef<EamWorkRequestListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EAMListDialogData) {
    
    this.AssetName= this.data.eamAsset;
   }

  ngOnInit() {
    this.getworkorders(this.AssetName)
  }

  getworkorders(assetname: string) : void{
    this.isLoading = true;
    this.svcEAM.getEAMWorkorders(assetname).pipe(
      pluck('Body')
    ).subscribe((assets:any) => {
      this.isLoading = false;     
      this.datasource = assets ? assets : []

      if (this.datasource.length > 1){
        this.workOrdersExist = true
      } else {
        this.workOrdersExist = false
      }
   
    })
  }

  close(): void {
    this.dialogRef.close()
  }

}
